var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelarCartao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 36,
    viewBox: "0 0 46 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.3886 29.4674L36.6713 25.7502L40.3886 22.0329C40.543 21.8677 40.6272 21.6489 40.6233 21.4228C40.6195 21.1967 40.528 20.9809 40.3681 20.8209C40.2081 20.661 39.9924 20.5695 39.7662 20.5657C39.5401 20.5618 39.3213 20.646 39.1561 20.8004L35.4388 24.5177L31.7216 20.8004C31.5563 20.646 31.3376 20.5618 31.1115 20.5657C30.8853 20.5695 30.6695 20.661 30.5096 20.8209C30.3497 20.9809 30.2582 21.1967 30.2543 21.4228C30.2505 21.6489 30.3347 21.8677 30.4891 22.0329L34.2064 25.7502L30.4891 29.4674C30.4036 29.5473 30.3351 29.6436 30.2876 29.7505C30.2401 29.8574 30.2146 29.9728 30.2126 30.0898C30.2106 30.2068 30.2322 30.323 30.276 30.4314C30.3199 30.5399 30.3851 30.6384 30.4679 30.7211C30.5506 30.8039 30.6491 30.8691 30.7576 30.913C30.8661 30.9568 30.9822 30.9784 31.0992 30.9764C31.2162 30.9744 31.3316 30.9489 31.4385 30.9014C31.5454 30.8539 31.6417 30.7854 31.7216 30.6999L35.4388 26.9827L39.1561 30.6999C39.236 30.7854 39.3323 30.8539 39.4392 30.9014C39.5461 30.9489 39.6615 30.9744 39.7785 30.9764C39.8954 30.9784 40.0116 30.9568 40.1201 30.913C40.2286 30.8691 40.3271 30.8039 40.4098 30.7211C40.4926 30.6384 40.5578 30.5399 40.6016 30.4314C40.6455 30.323 40.6671 30.2068 40.6651 30.0898C40.6631 29.9728 40.6376 29.8574 40.5901 29.7505C40.5426 29.6436 40.4741 29.5473 40.3886 29.4674Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9409 25.851H5.16089C4.36524 25.851 3.60218 25.5349 3.03957 24.9723C2.47696 24.4097 2.16089 23.6466 2.16089 22.851V4.85095C2.16089 4.0553 2.47696 3.29224 3.03957 2.72963C3.60218 2.16702 4.36524 1.85095 5.16089 1.85095H32.1609C32.9565 1.85095 33.7196 2.16702 34.2822 2.72963C34.8448 3.29224 35.1609 4.0553 35.1609 4.85095V15.731",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16089 10.851H35.1609",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelarCartao);
export default __webpack_public_path__ + "static/media/cancelarCartao.11670b6362f9972a624f6de5dd5fee12.svg";
export { ForwardRef as ReactComponent };